import {createSlice} from '@reduxjs/toolkit';

export const initialAppState = {
  headline: '',
  subHeadline: '',
  dispatchType: '',
  ratings: [],
  serviceLinks: [],
  ajaxCart: false,
  priceDisplay: 'gross',
  shortDescription: null,
  configuratorType: '',
  currencySymbol: '',
  application: 'null',
  hasBanner: false,
  nodeId: null,
  isParagraph: false,
  paymentMethods: [],
  hasTabs: false,
  // DPLE template-led mode. Activated via ?predesign=...&mode=dple URL params.
  // When enabled, the gallery is replaced with the DPLE editor and shape/format
  // are hidden from the right rail (locked by the predesign).
  dple: {
    enabled: false,
    sku: null,
    predesignName: null,
    endpoint: null,
    target: null,
    consumer: null,
    sdkUrl: null,
    // Integer label dimensions (mm) parsed from ?cw=&ch=. Stored here so the
    // DPLE preview can reserve an aspect-ratio box up-front and avoid CLS
    // when the SDK eventually injects the canvas.
    cw: null,
    ch: null,
  },
};

export const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    overwriteState: (state, {payload}) => {
      return {...state, ...payload};
    }
  },
});

export const {overwriteState} = appSlice.actions;

export default appSlice.reducer;

export const appSelector = (state) => state.app;
export const ratingsSelector = (state) => state.app.ratings;

// Subscribe to a primitive boolean rather than the whole `dple` object so
// non-DPLE pages don't re-render when unrelated `app` state changes.
export const dpleEnabledSelector = (state) => state.app.dple?.enabled === true;
export const dpleConfigSelector = (state) => state.app.dple;
